import { c as _c } from "react/compiler-runtime";
import { SphereCircularProgress } from "@components/common/sphere-circular-progress";
import { Box } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { sidebarSelector } from "@store/ui/ui-selector";
import { FontWeights, Tooltip } from "@flat-ui";
import { withEllipsis } from "@styles/common-styles";
import { nounPluralize } from "@utils/data-display";
import { useMemo } from "react";

/** Default trial duration in days */
const DEFAULT_TRIAL_DURATION = 21;
/** Circular progress indicator that shows the remaining days of a trial subscription */
export function TrialCountdownIndicator(t0) {
  const $ = _c(19);
  const {
    remainingDays,
    trialDuration
  } = t0;
  const {
    isFullSize
  } = useAppSelector(sidebarSelector);
  let t1;
  if ($[0] !== remainingDays) {
    t1 = nounPluralize({
      counter: remainingDays,
      word: "day"
    });
    $[0] = remainingDays;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const text = `${t1} left`;
  const t2 = isFullSize ? "18px" : "2px";
  let t3;
  if ($[2] !== t2) {
    t3 = {
      paddingY: "8px",
      paddingLeft: t2,
      paddingRight: "2px",
      width: "100%",
      ...withEllipsis
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isFullSize ? "normal" : "center";
  let t5;
  if ($[4] !== t4) {
    t5 = {
      display: "flex",
      alignItems: "center",
      justifyContent: t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = trialDuration ?? DEFAULT_TRIAL_DURATION;
  let t7;
  if ($[6] !== remainingDays || $[7] !== t6) {
    t7 = <SphereCircularProgress value={remainingDays} maxValue={t6} unit="" size={34} thickness={6} />;
    $[6] = remainingDays;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== isFullSize || $[10] !== text) {
    t8 = isFullSize && <Box data-testid="trial-countdown-indicator-details" sx={{
      marginLeft: "6px",
      ...withEllipsis
    }}><Box sx={{
        fontSize: "14px",
        fontWeight: FontWeights.Regular,
        color: "text.primary",
        ...withEllipsis
      }}>Trial period</Box><Box sx={{
        fontSize: "10px",
        fontWeight: FontWeights.Regular,
        color: "text.secondary",
        ...withEllipsis
      }}>{text}</Box></Box>;
    $[9] = isFullSize;
    $[10] = text;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t7 || $[14] !== t8) {
    t9 = <Tooltip component="div" title="Upgrade now to keep access to all your projects."><Box sx={t5}>{t7}{t8}</Box></Tooltip>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t9) {
    t10 = <Box data-testid="trial-countdown-indicator" component="div" sx={t3}>{t9}</Box>;
    $[16] = t3;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}